import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MarketplaceCardModule } from 'src/app/shared/components/marketplace-card/marketplace-card.module';
import { PageTopSectionModule } from 'src/app/shared/components/page-top-section/page-top-section.module';
import { SwiperModule } from 'swiper/angular';

import { AdvertDetailsRightAreaComponent } from './product-details-right-area/advert-details-right-area.component';
import { ProductDetailsRoutingModule } from './product-details-routing.module';
import { ProductDetailsComponent } from './product-details.component';
import { SelectDaysComponent } from './select-days/select-days.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { SharedModule } from 'shared/shared.module';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { ProductDetailsPricingComponent } from './product-details-pricing/product-details-pricing.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AdvertReportComponent } from './advert-report/advert-report.component';
import { MaterialModule } from 'src/app/material/material.module';
import { ProductDetailsImageAreaComponent } from './product-details-image-area/product-details-image-area.component';
import { TranslateModule } from '@ngx-translate/core';
import { AdvertDetailsListItemComponent } from './product-details-right-area/advert-details-list-item.component';

@NgModule({
  declarations: [
    ProductDetailsComponent,
    ProductDetailsImageAreaComponent,
    AdvertDetailsRightAreaComponent,
    SelectDaysComponent,
    ProductDetailsPricingComponent,
    AdvertReportComponent,
  ],
  imports: [
    CommonModule,
    ProductDetailsRoutingModule,
    SwiperModule,
    PageTopSectionModule,
    MarketplaceCardModule,
    PipesModule,
    SharedModule,
    NgxImageZoomModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
    AdvertDetailsListItemComponent,
  ],
})
export class ProductDetailsModule {}
